import { useEffect } from 'react'
import { DistributionList } from './Groups';

type RequireListOptions = {
  shouldRequire: boolean
  missingMessage: string
  close: () => void
}

export function useCloseOnMissingList(
  list: DistributionList | undefined,
  addNotification: (n: { variant: 'notice' | 'alert'; message: string }) => void,
  { shouldRequire, missingMessage, close }: RequireListOptions,
) {
  useEffect(() => {
    if (shouldRequire && !list) {
      addNotification({ variant: 'alert', message: missingMessage })
      close()
    }
  }, [shouldRequire, list, addNotification, missingMessage, close])
}
